var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-password_show"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password_show",
    clipPath: "url(#clip-password_show)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858",
    transform: "translate(-310.809 -243.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M297.015,250.082c-5.047,0-9.623,2.761-13,7.245a1.045,1.045,0,0,0,0,1.248c3.377,4.49,7.953,7.252,13,7.252s9.622-2.762,13-7.246a1.045,1.045,0,0,0,0-1.248C306.637,252.843,302.061,250.082,297.015,250.082Zm.361,13.415a5.555,5.555,0,1,1,5.181-5.181A5.558,5.558,0,0,1,297.376,263.5Zm-.167-2.56A2.991,2.991,0,1,1,300,258.143,2.987,2.987,0,0,1,297.209,260.937Z",
    transform: "translate(29)",
    fill: "#33475b",
    opacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password_show.09b4f7d2e3f565f80796b1408616eb31.svg";
export { ForwardRef as ReactComponent };